<div
  class="dialog-content-wrapper"
  style="height: 100%; display: flex; flex-direction: column">
  <mat-toolbar class="mat-accent m-0 eventdetailtoolbar">
    <mat-toolbar-row
      style="
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        height: fit-content;
      ">
      <span class="title dialog-title"
        >{{ event.EventName }} | {{ event.DeviceName }} | {{ event.EventId }}
      </span>
      <div
        style="display: flex; flex-direction: row; justify-content: flex-end">
        <button
          mat-icon-button
          (click)="dialogRef.close()"
          aria-label="Close dialog">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>

  <mat-dialog-content>
    <div
      *ngIf="event.Images && event.Images.length > 0"
      class="event-details_dialogbox">
      <div
        class="event-details_images_grid-container event-details_images_grid-container--fit">
        <div
          class="event-details_images_grid-element"
          *ngFor="let img of event.Images">
          <img
            src="{{ img.Path }}"
            (click)="toggleshowImageContainer(img.Path)" />
        </div>
      </div>
      <!-- <section id="photos">
          <img  *ngFor="let img of event.Images"
            src="{{ img.Path }}"
            (click)="toggleshowImageContainer(img.Path)" />
      </section> -->
      <div class="slideshow-container">
        <!-- Full-width images with number and caption text -->
        <div class="mySlides">
          <div
            fxLayout="row"
            style="overflow: hidden; height: inherit; width: 100%">
            <!-- <img id="img" src={{singleImage}} style="width:700px !important ; height:400px !important" class="pannable-image" />  -->
            <div id="openseadragon"></div>
          </div>
          <!-- <div id="openseadragon1" style="width: 710px; height: 846px; "></div> -->
        </div>
        <!-- Next and previous buttons -->
        <a class="prev" (click)="plusSlides(slideIndex - 1)">&#10094;</a>
        <a class="next" (click)="plusSlides(slideIndex + 1)">&#10095;</a>
      </div>

      <div>
        <!-- <div *ngFor="let img of event.Images">
                <lib-ngx-image-zoom [thumbImage]="img.Path" [fullImage]="img.Path" [magnification]="3"
                    [enableScrollZoom]="true" [enableLens]="true" [lensWidth]="200"></lib-ngx-image-zoom>
                <span *ngIf="img" style="margin-left: 40%;font-size: 20px;font-weight: 900;">{{img.Name}}</span>
                <img *ngIf="img" src={{img.Path}} width="300" height="300" style="margin-left:25%" />
            </div> -->
      </div>
    </div>
    <div class="event-details_table">
      <div *ngIf="event.Properties">
        <h2 class="margin-bottom : 10px;">Event Properties</h2>
        <ng-container *ngFor="let option of event | keyvalue">
          <ng-container *ngIf="option.key == 'Properties'">
            <div
              class="event-details_properties_row event-details_properties_row--fit">
              <div *ngFor="let property of eventproperties">
                <p *ngIf="property.key && property.value">
                  {{ property.key }} : {{ property.value }}
                </p>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions
    class="m-0 p-16"
    style="display: flex; flex-direction: row; justify-content: space-between">
    <button
      (click)="showPreviousEvent()"
      mat-raised-button
      class="save-button mat-accent"
      aria-label="Prev">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <button
      (click)="showNextEvent()"
      mat-raised-button
      class="save-button mat-accent"
      aria-label="Next">
      <mat-icon>arrow_forward</mat-icon>
    </button>
  </mat-dialog-actions>
</div>
